/*
 * Generated by tutor-mfe for all.
 *
 * Frontend-base counterpart of the legacy env.config.jsx.
 */

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';

import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedUser } from '@edx/frontend-platform/auth';
import {
  breakpoints, Button, Card, Icon, useMediaQuery,
} from '@openedx/paragon';
import { Calendar, Nightlight, WbSunny } from '@openedx/paragon/icons';
import { useIntl } from '@edx/frontend-platform/i18n';
// Saberes INTERSSAN (pedido 126): foto do perfil (a do Google, para quem entra com o Google, ou a enviada
// no perfil) ao lado do nome, no botão do usuário do topo dos apps — com o anel âmbar do Saberes. Sem foto,
// as iniciais num círculo azul. A foto vem de /saberes/api/papel/ (saberes_platform.views.papel), a mesma
// chamada do botão "Meus cursos no Studio". No celular fica só a foto, como o ícone padrão fazia.
// (estilos fora do JSX: chaves duplas quebrariam o Jinja do Tutor)
const SABERES_AVATAR_STYLE = {
  width: 30,
  height: 30,
  borderRadius: '50%',
  objectFit: 'cover',
  flex: 'none',
  boxShadow: '0 0 0 2px #fff, 0 0 0 4px #F6AE2F',
  margin: '0 8px 0 3px',
};
const SABERES_INICIAIS_STYLE = {
  ...SABERES_AVATAR_STYLE,
  display: 'inline-grid',
  placeItems: 'center',
  background: 'linear-gradient(135deg, #016387, #028492)',
  color: '#fff',
  fontWeight: 700,
  fontSize: 12,
  lineHeight: 1,
};
const SABERES_TOGGLE_STYLE = { display: 'inline-flex', alignItems: 'center' };

let saberesPapelPromise = null;
const saberesPapel = () => {
  if (!saberesPapelPromise) {
    saberesPapelPromise = fetch(`${getConfig().LMS_BASE_URL}/saberes/api/papel/`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }
  return saberesPapelPromise;
};

const SaberesAvatar = () => {
  const usuario = getAuthenticatedUser();
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    saberesPapel().then((dados) => setAvatar(dados && dados.avatar ? dados.avatar : null));
  }, []);

  // pedido 190: nome e último sobrenome (“André Alvarenga”), não o login; o login só enquanto o nome não chega
  const partes = ((avatar && avatar.nome) || '').trim().split(/\s+/).filter(Boolean);
  const nomeCurto = partes.length > 1 ? `${partes[0]} ${partes[partes.length - 1]}` : (partes[0] || '');
  const nome = nomeCurto || (usuario ? usuario.username : '');
  const iniciais = (avatar && avatar.iniciais) || (nome ? nome[0].toUpperCase() : '?');
  return (
    <span style={SABERES_TOGGLE_STYLE}>
      {avatar && avatar.foto ? (
        <img src={avatar.foto} alt="" width="30" height="30" style={SABERES_AVATAR_STYLE} />
      ) : (
        <span aria-hidden="true" style={SABERES_INICIAIS_STYLE}>{iniciais}</span>
      )}
      <span data-hj-suppress className="d-none d-md-inline">{nome}</span>
    </span>
  );
};
// Saberes INTERSSAN (pedido 139): aviso de cookies (LGPD) nos apps — o mesmo do site (saberes_platform/templates/
// saberes_platform/_rodape_extra.html): texto positivo, "Aceitar" em destaque, recusa discreta. O Google Analytics
// só carrega depois do aceite. A escolha fica no cookie "saberes_cookies" do domínio inteiro, então quem já
// respondeu no site não é perguntado de novo aqui. Roda fora do React (como o saberesAuthnEnhance), em todos os
// apps, inclusive Entrar/Criar conta. O ID do GA vem do LMS (MFE_CONFIG["SABERES_GA4_ID"]), que só chega depois
// da chamada à API de configuração — por isso espera até ~15 s; sem ID (GA desligado), não mostra nada.
const saberesCookies = () => {
  if (typeof window === 'undefined' || window.__sabCookies) {
    return;
  }
  window.__sabCookies = true;
  const NOME = 'saberes_cookies';
  const ler = () => {
    const m = document.cookie.match(/(?:^|; )saberes_cookies=([^;]*)/);
    return m ? m[1] : null;
  };
  const dominio = () => {
    const h = window.location.hostname;
    if (/^[\d.]+$/.test(h) || h.indexOf('.') < 0) {
      return '';
    }
    return `; domain=.${h.replace(/^(apps|studio|www)\./, '')}`;
  };
  const gravar = (v) => {
    document.cookie = `${NOME}=${v}; path=/; max-age=31536000; SameSite=Lax${dominio()}${window.location.protocol === 'https:' ? '; Secure' : ''}`;
    if (v === 'recusado') {
      document.cookie.split('; ').forEach((c) => {
        const n = c.split('=')[0];
        if (/^_ga/.test(n)) {
          ['', dominio(), `; domain=${window.location.hostname}`].forEach((d) => {
            document.cookie = `${n}=; path=/; max-age=0${d}`;
          });
        }
      });
    }
  };
  let ga = '';
  const carregarGA = () => {
    if (!ga || window.__sabGA) {
      return;
    }
    window.__sabGA = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
    window.gtag('js', new Date());
    window.gtag('config', ga);
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
    document.head.appendChild(s);
  };
  let aviso = null;
  const montar = () => {
    if (aviso) {
      return aviso;
    }
    const lms = (getConfig().LMS_BASE_URL || '').replace(/\/$/, '');
    const estilo = document.createElement('style');
    estilo.textContent = [
      '.sab-cookies{position:fixed;left:16px;right:16px;bottom:16px;z-index:2000;max-width:980px;margin:0 auto;display:flex;align-items:center;gap:18px 24px;flex-wrap:wrap;padding:16px 20px;border-radius:18px;background:#0A2A38;color:rgba(255,255,255,.94);box-shadow:0 14px 40px rgba(10,42,56,.35);transform:translateY(140%);transition:transform .35s ease;font-family:Inter,sans-serif}',
      '.sab-cookies--visivel{transform:translateY(0)}',
      '.sab-cookies p{flex:1 1 380px;margin:0;font-size:.92rem;line-height:1.55;color:inherit}',
      '.sab-cookies a{color:#F6AE2F;text-decoration:underline;font-weight:600}',
      '.sab-cookies__acoes{display:flex;gap:10px;align-items:center;flex-wrap:wrap}',
      '.sab-cookies__aceitar{background:#F6AE2F;color:#1D1300;border:0;border-radius:99px;padding:12px 24px;font-weight:700;font-size:.95rem;cursor:pointer;box-shadow:0 6px 18px rgba(246,174,47,.4);white-space:nowrap}',
      '.sab-cookies__aceitar:hover,.sab-cookies__aceitar:focus-visible{background:#FFBE4A}',
      '.sab-cookies__recusar{background:transparent;color:rgba(255,255,255,.78);border:0;padding:10px 6px;font-size:.85rem;text-decoration:underline;cursor:pointer;white-space:nowrap}',
      '.sab-cookies button:focus-visible{outline:3px solid #fff;outline-offset:2px}',
      '@media (max-width:600px){.sab-cookies{left:10px;right:10px;bottom:10px;padding:14px 16px}.sab-cookies__acoes{width:100%;justify-content:space-between}.sab-cookies__aceitar{flex:1}}',
      '@media (prefers-reduced-motion:reduce){.sab-cookies{transition:none}}',
    ].join('');
    document.head.appendChild(estilo);
    aviso = document.createElement('div');
    aviso.className = 'sab-cookies';
    aviso.setAttribute('role', 'region');
    aviso.setAttribute('aria-label', 'Aviso de cookies');
    aviso.innerHTML = '<p><span aria-hidden="true">🍪</span> Usamos cookies para lembrar de você e entender quais cursos e páginas mais ajudam quem estuda — é assim que o Saberes melhora para todo mundo. Sem anúncios, e suas notas e dados de estudo não saem daqui. '
      + `<a href="${lms}/privacy#cookies">Saiba mais</a></p>`
      + '<div class="sab-cookies__acoes"><button type="button" class="sab-cookies__aceitar" data-sab-cookie="aceito">Aceitar e continuar</button>'
      + '<button type="button" class="sab-cookies__recusar" data-sab-cookie="recusado">Só os necessários</button></div>';
    aviso.addEventListener('click', (e) => {
      const b = e.target.closest('[data-sab-cookie]');
      if (!b) {
        return;
      }
      const v = b.getAttribute('data-sab-cookie');
      gravar(v);
      if (v === 'aceito') {
        carregarGA();
      }
      aviso.classList.remove('sab-cookies--visivel');
    });
    document.body.appendChild(aviso);
    return aviso;
  };
  const mostrar = () => {
    if (!ga) {
      return;
    }
    const a = montar();
    window.requestAnimationFrame(() => a.classList.add('sab-cookies--visivel'));
  };
  // "Preferências de cookies" (rodapé dos apps e do site): reabre o aviso
  document.addEventListener('click', (e) => {
    const l = e.target.closest && e.target.closest('[data-sab-cookies]');
    if (l && ga) {
      e.preventDefault();
      mostrar();
    }
  });
  let tentativas = 0;
  const esperarConfig = () => {
    ga = getConfig().SABERES_GA4_ID || '';
    if (!ga && tentativas < 30) {
      tentativas += 1;
      window.setTimeout(esperarConfig, 500);
      return;
    }
    const escolha = ler();
    if (escolha === 'aceito') {
      carregarGA();
    } else if (!escolha) {
      window.setTimeout(mostrar, 900);
    }
  };
  esperarConfig();
};

import { DIRECT_PLUGIN, IFRAME_PLUGIN, PLUGIN_OPERATIONS } from '@openedx/frontend-plugin-framework';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }
  config.pluginSlots[slot_name].plugins.push(...plugins);
}
let themeVariant = 'selected-paragon-theme-variant';

const AddDarkTheme = () => {
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const addDarkThemeToIframes = () => {
    const iframes = document.getElementsByTagName('iframe');
    const iframesLength = iframes.length;
    if (iframesLength > 0) {
      Array.from({ length: iframesLength }).forEach((_, index) => {
        const style = document.createElement('style');
        style.textContent = `
          body {
            background-color: #0D0D0E;
            color: #ccc;
          }
          a { color: #ccc; }
          a:hover { color: #d3d3d3; }
        `;
        if (iframes[index].contentDocument) {
          iframes[index].contentDocument.head.appendChild(style);
        }
      });
    }
  };

  useEffect(() => {
    const theme = window.localStorage.getItem(themeVariant);

    // - When page loads, Footer loads before MFE content. Since there is no iframe on page,
    // it does not append any class. MutationObserver observes changes in DOM and hence appends dark
    // attributes when iframe is added. After 15 sec, this observer is destroyed to conserve resources. 
    // - It has been added outside dark-theme condition so that it can be removed on Component Unmount.
    // - Observer can be passed to `addDarkThemeToIframes` function and disconnected after observing Iframe.
    // This approach has a limitation: the observer first detects the iframe and then detects the docSrc. 
    // We need to wait for docSrc to fully load before appending the style tag.
    const observer = new MutationObserver(() => {
      addDarkThemeToIframes();
    });

    if (isThemeToggleEnabled && theme === 'dark') {
      document.documentElement.setAttribute('data-paragon-theme-variant', 'dark');

      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer?.disconnect(), 15000); // clear after 15 sec to avoid resource usage
    }

    return () => observer?.disconnect();
  }, []);

  return (<div />);
};

function setConfig() {
  const config = {
    pluginSlots: {},
  };
// Saberes INTERSSAN: rodapé dos MFEs — mesmo conteúdo do footer.html do LMS.
// (o nome IndigoFooter é mantido porque os slots do tema apontam para ele)
const SABERES_FOOTER_CSS = `.sab-scroll{position:fixed;right:28px;bottom:28px;z-index:60;opacity:0;visibility:hidden;transform:translateY(12px);transition:opacity .25s,transform .25s,visibility .25s;}
.sab-scroll.visible{opacity:1;visibility:visible;transform:translateY(0);}
.sab-scroll__btn{position:relative;width:56px;height:56px;border-radius:50%;padding:0;cursor:pointer;background:#fff;border:1px solid #D5E2E8;box-shadow:0 6px 18px rgba(10,42,56,.22);display:flex;align-items:center;justify-content:center;transition:background .25s,border-color .25s;}
.sab-scroll__btn:hover,.sab-scroll__btn:focus-visible{background:#016387;border-color:#016387;outline:none;}
.sab-scroll__ring{position:absolute;inset:0;width:100%;height:100%;transform:rotate(-90deg);pointer-events:none;}
.sab-scroll__ring-bg{fill:none;stroke:#E3EAEE;stroke-width:3;}
.sab-scroll__ring-fill{fill:none;stroke:url(#sabScrollGrad);stroke-width:3;stroke-linecap:round;stroke-dasharray:157.08;stroke-dashoffset:157.08;transition:stroke-dashoffset .1s linear;}
.sab-scroll__pct,.sab-scroll__arrow{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(1);transition:opacity .2s,transform .2s;}
.sab-scroll__pct{font-family:'Outfit','Inter',sans-serif;font-size:.78rem;font-weight:700;color:#0A2A38;white-space:nowrap;}
.sab-scroll__arrow{opacity:0;color:#fff;width:20px;height:20px;transform:translate(-50%,-50%) scale(.6);}
.sab-scroll__btn:hover .sab-scroll__pct,.sab-scroll__btn:focus-visible .sab-scroll__pct{opacity:0;transform:translate(-50%,-50%) scale(.6);}
.sab-scroll__btn:hover .sab-scroll__arrow,.sab-scroll__btn:focus-visible .sab-scroll__arrow{opacity:1;transform:translate(-50%,-50%) scale(1);}
body.indigo-dark-theme .sab-scroll__btn,[data-paragon-theme-variant="dark"] .sab-scroll__btn{background:#142530;border-color:#22394A;}
body.indigo-dark-theme .sab-scroll__pct,[data-paragon-theme-variant="dark"] .sab-scroll__pct{color:#EEF3F5;}
body.indigo-dark-theme .sab-scroll__ring-bg,[data-paragon-theme-variant="dark"] .sab-scroll__ring-bg{stroke:#22394A;}
@media (max-width:600px){.sab-scroll{right:16px;bottom:16px;}.sab-scroll__btn{width:48px;height:48px;}}
@media (max-width:960px){.view-sab-course .sab-scroll{bottom:92px;}}
@media (prefers-reduced-motion:reduce){.sab-scroll,.sab-scroll__ring-fill,.sab-scroll__pct,.sab-scroll__arrow{transition:none;}}
.sab-footer__by{display:inline-flex;flex-direction:column;gap:6px;margin-top:20px;opacity:.75;text-decoration:none;}.sab-footer__by:hover{opacity:1;}.sab-footer__by small{font-family:'Outfit','Inter',sans-serif;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#8FAAB5;}.sab-footer__by img{display:block;height:30px;width:auto;}
.sab-footer-host{background:transparent;padding:0;margin:0;border:0;}
.sab-footer{background:#0A2A38;color:#C9DCE3;font-family:'Inter',sans-serif;position:relative;margin-top:0;padding:0;}
.sab-footer::before{content:"";display:block;height:4px;background:linear-gradient(90deg,#4E9655,#F6AE2F);}
.sab-footer .sab-wrap{max-width:1200px;margin:0 auto;padding-left:clamp(16px,4vw,32px);padding-right:clamp(16px,4vw,32px);}
.sab-footer__grid{display:grid;grid-template-columns:minmax(0,1.6fr) repeat(3,minmax(0,1fr));gap:32px 40px;padding-top:56px;padding-bottom:40px;}
.sab-footer__brand img{display:block;height:auto;max-width:190px;margin:0 0 16px;}
.sab-footer__brand p{margin:0;max-width:40ch;font-size:14.5px;line-height:1.65;color:#A9C4CE;}
.sab-footer__col h2{margin:0 0 14px;font-family:'Outfit','Inter',sans-serif;font-size:13px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:#9FE1EC;}
.sab-footer__col ul{list-style:none;margin:0;padding:0;}
.sab-footer__col li{margin:0 0 10px;padding:0;}
.sab-footer__col a{color:#E3EEF2;text-decoration:none;font-size:15px;}
.sab-footer__col a:hover,.sab-footer__col a:focus{color:#FFD27F;text-decoration:underline;}
.sab-footer__bottom{display:flex;flex-wrap:wrap;justify-content:space-between;gap:8px 24px;padding-top:20px;padding-bottom:28px;border-top:1px solid rgba(255,255,255,.12);font-size:13px;color:#8FAAB5;}
@media (max-width:860px){.sab-footer__grid{grid-template-columns:repeat(2,minmax(0,1fr));}.sab-footer__brand{grid-column:1 / -1;}}
@media (max-width:480px){.sab-footer__grid{grid-template-columns:minmax(0,1fr);}}`;

const SAB_SCROLL_SVG = { __html: '<defs><linearGradient id="sabScrollGrad" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#4E9655"/><stop offset="1" stop-color="#F6AE2F"/></linearGradient></defs><circle class="sab-scroll__ring-bg" cx="28" cy="28" r="25"></circle><circle class="sab-scroll__ring-fill" cx="28" cy="28" r="25"></circle>' };
const sabScrollInit = () => {
  var C=157.08,w=document.getElementById('sabScroll');
  if(!w||w.getAttribute('data-ready')){return;} w.setAttribute('data-ready','1');
  var fill=w.querySelector('.sab-scroll__ring-fill'),pct=w.querySelector('.sab-scroll__pct');
  function upd(){var h=document.documentElement.scrollHeight-window.innerHeight;var p=h>0?Math.min(100,Math.round(window.scrollY/h*100)):0;
    w.classList.toggle('visible',window.scrollY>600);fill.style.strokeDashoffset=String(C-p/100*C);pct.textContent=p+'%';}
  w.querySelector('button').addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
  window.addEventListener('scroll',upd,{passive:true});upd();
};

// Saberes (pedido 193): VLibras nos apps do curso, perfil, conta e Studio — o mesmo script das páginas do LMS
// (/saberes/vlibras.js, saberes_platform/acessibilidade.py), com a mãozinha arrastável. A aula, que abre num quadro,
// não carrega o seu: antes o VLibras aparecia preso dentro da unidade.
// Pedido 196 (B4): o menu recolhível com ícones (☰ ao lado do logo) vem do mesmo jeito, de /saberes/menu.js
const sabScriptsDoLms = (lms) => {
  if (typeof document === 'undefined') {
    return;
  }
  [['sab-vlibras-js', 'vlibras.js'], ['sab-menu-js', 'menu.js']].forEach(([id, arquivo]) => {
    if (document.getElementById(id)) {
      return;
    }
    const s = document.createElement('script');
    s.id = id;
    s.src = `${lms}/saberes/${arquivo}`;
    s.defer = true;
    document.body.appendChild(s);
  });
};

// Saberes (pedido 190): o cabeçalho do Studio não tem área de encaixe para o usuário e escreve o login
// (“andre_alvarenga”). Depois que a página monta, troca o login no topo pelo nome curto e o ícone genérico pela
// foto — os outros apps já mostram nome e foto pelo SaberesAvatar.
const sabNomeNoTopo = (lms) => {
  const usuario = getAuthenticatedUser();
  if (!usuario || !usuario.username || typeof document === 'undefined') {
    return;
  }
  fetch(`${lms}/saberes/api/papel/`, { credentials: 'include' })
    .then((r) => (r.ok ? r.json() : null))
    .then((dados) => {
      const av = dados && dados.avatar;
      const partes = ((av && av.nome) || '').trim().split(/\s+/).filter(Boolean);
      if (!partes.length) {
        return;
      }
      const curto = partes.length > 1 ? `${partes[0]} ${partes[partes.length - 1]}` : partes[0];
      const trocar = () => {
        document.querySelectorAll('header button, header a, header span').forEach((el) => {
          el.childNodes.forEach((n) => {
            if (n.nodeType === 3 && n.textContent.trim() === usuario.username) {
              n.textContent = n.textContent.replace(usuario.username, curto);
              const icone = el.querySelector('svg');
              if (av.foto && icone && !el.querySelector('.sab-foto-topo')) {
                const img = document.createElement('img');
                img.src = av.foto; img.alt = ''; img.width = 28; img.height = 28; img.className = 'sab-foto-topo';
                img.style.cssText = 'border-radius:50%;object-fit:cover;margin-right:8px;box-shadow:0 0 0 2px #fff,0 0 0 4px #F6AE2F';
                icone.replaceWith(img);
              }
            }
          });
        });
      };
      trocar();
      // o cabeçalho às vezes monta depois do rodapé: tenta de novo por alguns segundos
      let n = 0;
      const t = setInterval(() => { trocar(); n += 1; if (n > 10) { clearInterval(t); } }, 500);
    })
    .catch(() => {});
};

const IndigoFooter = () => {
  const config = getConfig();
  useEffect(() => { sabScrollInit(); sabScriptsDoLms(config.LMS_BASE_URL); sabNomeNoTopo(config.LMS_BASE_URL); }, []);
  const lmsLink = (u) => (u.startsWith('http') ? u : `${config.LMS_BASE_URL}${u}`);
  return (
    <div className="wrapper wrapper-footer sab-footer-host">
      <style>{SABERES_FOOTER_CSS}</style>
      <footer id="footer" className="sab-footer">
        <div className="sab-wrap sab-footer__grid">
          <div className="sab-footer__brand">
            <a href={lmsLink('/')} aria-label="Saberes INTERSSAN — página inicial">
              <img src={`${config.LMS_BASE_URL}/static/indigo/images/logo-white.png?v=2`} alt="Saberes INTERSSAN.org" width="160" height="41" />
            </a>
            <p>Plataforma de formação do INTERSSAN/UNESP em Soberania e Segurança Alimentar e Nutricional, aberta a todos os países de língua portuguesa.</p>
            <a className="sab-footer__by" href="https://interssan.org" target="_blank" rel="noreferrer">
              <small>Uma iniciativa do</small>
              <img src={`${config.LMS_BASE_URL}/static/indigo/images/interssan-horizontal-white.png`} alt="INTERSSAN — Centro de Inovação em Soberania e Segurança Alimentar" />
            </a>
          </div>
          <nav className="sab-footer__col" aria-label="Plataforma">
            <h2>Plataforma</h2>
            <ul><li><a href={lmsLink("/courses")}>Cursos</a></li><li><a href={lmsLink("/#como-funciona")}>Como funciona</a></li><li><a href={lmsLink("/dashboard")}>Meus cursos</a></li><li><a href={lmsLink("/help")}>Ajuda</a></li><li><a href={lmsLink("/saberes/professor/")}>Central do Professor</a></li></ul>
          </nav>
          <nav className="sab-footer__col" aria-label="Institucional">
            <h2>Institucional</h2>
            <ul><li><a href={lmsLink("/about")}>Sobre o Saberes</a></li><li><a href={lmsLink("https://interssan.org")} target="_blank" rel="noreferrer">INTERSSAN.org</a></li><li><a href={lmsLink("https://pisa.interssan.org")} target="_blank" rel="noreferrer">Plataforma PISA</a></li><li><a href={lmsLink("/contact")}>Contato</a></li><li><a href={lmsLink("/saberes/novidades/")}>Novidades</a></li><li><a href={lmsLink("/saberes/validar/")}>Validar certificado</a></li><li><a href={lmsLink("/saberes/acessibilidade/")}>Acessibilidade</a></li></ul>
          </nav>
          <nav className="sab-footer__col" aria-label="Legal">
            <h2>Legal</h2>
            <ul><li><a href={lmsLink("/tos")}>Termos de uso</a></li><li><a href={lmsLink("/privacy")}>Privacidade</a></li><li><a href={lmsLink("/privacy#cookies")} data-sab-cookies="">Preferências de cookies</a></li></ul>
          </nav>
        </div>
        <div className="sab-wrap sab-footer__bottom">
          <span>© {new Date().getFullYear()} INTERSSAN — Centro de Ciência, Tecnologia e Inovação para Soberania e Segurança Alimentar e Nutricional · UNESP</span>
          <span>Botucatu · São Paulo · Brasil</span>
        </div>
      </footer>
      <div className="sab-scroll" id="sabScroll">
        <button type="button" className="sab-scroll__btn" aria-label="Voltar ao topo" title="Voltar ao topo">
          <svg className="sab-scroll__ring" viewBox="0 0 56 56" aria-hidden="true" dangerouslySetInnerHTML={SAB_SCROLL_SVG} />
          <span className="sab-scroll__pct">0%</span>
          <svg className="sab-scroll__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7" /></svg>
        </button>
      </div>
    </div>
  );
};
const MobileViewHeader = () => {
  const config = getConfig();
  const intl = useIntl();
  const messages = {
    "mobile.view.header.logo.altText": {
      id: "mobile.view.header.logo.altText",
      defaultMessage: "Saberes INTERSSAN",
      description: "alt text for the mobile view header logo",
    },
  };

  const BASE_URL = config.LMS_BASE_URL;

  return (
    <>
      <style>
        {`
          #root .logo-image.logo-white {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root .logo-image {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root .logo-white {
            display: block;
          }
        `}
      </style>
      <a href={`${BASE_URL}/`} title="Saberes INTERSSAN" className="logo">
        <img className="logo-image" src={`${BASE_URL}/static/indigo/images/logo.png?v=2`} alt={intl.formatMessage(messages["mobile.view.header.logo.altText"])} />
        <img className="logo-image logo-white" src={`${BASE_URL}/static/indigo/images/logo-white.png?v=2`} alt={intl.formatMessage(messages["mobile.view.header.logo.altText"])} />
      </a>
    </>
  );
};
const ThemedLogo = () => {
  const BASE_URL = getConfig().LMS_BASE_URL;

  return (
    <>
      <style>
        {`
          #root header .logo-image.logo-white {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root header .logo-image {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root header .logo-white {
            display: block;
          }
        `}
      </style>
      <a href={`${BASE_URL}/`} title="Saberes INTERSSAN" className="logo">
        <img className="logo-image" src={`${BASE_URL}/static/indigo/images/logo.png?v=2`} alt="Saberes INTERSSAN — página inicial" />
        <img className="logo-image logo-white" src={`${BASE_URL}/static/indigo/images/logo-white.png?v=2`} alt="Saberes INTERSSAN — página inicial" />
      </a>
    </>
  );
};
const ToggleThemeButton = () => {
  const intl = useIntl();
  const [isDarkThemeEnabled, setIsDarkThemeEnabled] = useState(false);

  const themeCookieNames = [
    'selected-paragon-theme-variant',
    'selected-theme-variant',
  ];
  const themeAttributeNames = [
    'data-paragon-theme-variant',
    'data-theme-variant',
  ];
  const primaryCookie = themeCookieNames[0];
  const themeCookieExpiry = 90; // days
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const getCookie = (name) => {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1];
  };

  const getThemeCookie = () => {
    for (const name of themeCookieNames) {
      const value = getCookie(name);
      if (value !== undefined) {
        return value;
      }
    }
    return undefined;
  };

  const setCookie = (name, value, { domain, path, expires }) => {
    document.cookie = `${name}=${value}; domain=${domain}; path=${path}; expires=${expires.toUTCString()}; SameSite=Lax`;
  };

  const setThemeCookies = (value, opts) => {
    for (const name of themeCookieNames) {
      setCookie(name, value, opts);
    }
  };
  const setThemeAttribute = (theme) => {
    for (const attr of themeAttributeNames) {
      document.documentElement.setAttribute(attr, theme);
    }
  };

  const serverURL = new URL(getConfig().LMS_BASE_URL);

  const getCookieExpiry = () => {
    const today = new Date();
    return new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + themeCookieExpiry
    );
  };

  const getCookieOptions = (serverURL) => ({
    domain: serverURL.hostname,
    path: '/',
    expires: getCookieExpiry(),
  });

  const onToggleTheme = () => {
    let theme = '';

    if (getThemeCookie() === 'dark') {
      setThemeAttribute('light');
      setIsDarkThemeEnabled(false);
      theme = 'light';
    } else {
      setThemeAttribute('dark');
      setIsDarkThemeEnabled(true);
      theme = 'dark';
    }

    for (const name of themeCookieNames) {
        window.localStorage.setItem(name, theme);
    }
    setTimeout(() => {
      setThemeCookies(theme, getCookieOptions(serverURL));
      window.location.reload();
    }, 1);
  };

  useEffect(() => {
    const cookie = getThemeCookie();
    if (!cookie || cookie === 'undefined') {
      return;
    }
    if (cookie !== window.localStorage.getItem(primaryCookie)) {
      for (const name of themeCookieNames) {
          window.localStorage.setItem(name, cookie);
      }
      window.location.reload();
    }
    document.documentElement.setAttribute(themeAttributeNames[0], cookie);
  }, []);

  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      onToggleTheme();
    }
  };

  if (!isThemeToggleEnabled) {
    return <div />;
  }

  const messages = {
    "header.user.theme": {
      id: "header.user.theme",
      defaultMessage: "Alternar modo claro/escuro",
      description: "Toggle between light and dark theme",
    },
  };

  return (
    <div className="theme-toggle-button mr-3">
      <div className="light-theme-icon">
        <Icon src={WbSunny} />
      </div>
      <div className="toggle-switch">
        <label htmlFor="theme-toggle-checkbox" className="switch">
          <input
            id="theme-toggle-checkbox"
            defaultChecked={getThemeCookie() === "dark"}
            onChange={onToggleTheme}
            onKeyUp={handleKeyUp}
            type="checkbox"
            title={intl.formatMessage(messages["header.user.theme"])}
          />
          <span className="slider round" />
          <span id="theme-label" className="sr-only">{`Alternar para o modo ${isDarkThemeEnabled ? "claro" : "escuro"}`}</span>
        </label>
      </div>
      <div className="dark-theme-icon">
        <Icon src={Nightlight} />
      </div>
    </div>
  );
};
const getFullImageUrl = (path) => {
  if (!path) {
    return '';
  }
  return path.startsWith('http') ? path : `${getConfig().LMS_BASE_URL}${path}`;
};

const DATE_FORMAT_OPTIONS = { month: 'short', day: 'numeric', year: 'numeric' };

const messages = {
  startDate: {
    id: 'generic.course-card.start-date',
    defaultMessage: 'Início: {startDate}',
    description: 'Data de início.',
  }
};

const formatDate = (dateString, intl) => {
  const date = new Date(dateString);
  return intl.formatDate(date, DATE_FORMAT_OPTIONS);
};

const getStartDateDisplay = (courseData, intl) => {
  if (courseData?.advertisedStart) {
    return courseData.advertisedStart;
  }

  if (courseData?.start) {
    return formatDate(courseData.start, intl);
  }

  return '';
};

const CourseCard = ({
  isLoading,
  courseId,
  courseOrg,
  courseName,
  courseNumber,
  courseImageUrl,
  courseStartDate,
  courseAdvertisedStart,
}) => {
  const intl = useIntl();
  const isExtraSmall = useMediaQuery({ maxWidth: breakpoints.small.maxWidth });
  const noCourseImg = `${getConfig().LMS_BASE_URL}/theming/asset/images/no_course_image.png`;
  const startDateDisplay = (courseStartDate || courseAdvertisedStart) ? getStartDateDisplay({
    start: courseStartDate,
    advertisedStart: courseAdvertisedStart,
  }, intl) : null;

  return (
    <Card
      className={`course-card d-flex ${isExtraSmall ? 'w-100' : 'course-card-desktop'}`}
      isLoading={isLoading}
      data-testid="course-card"
    >
      <Card.ImageCap
        src={getFullImageUrl(courseImageUrl)}
        fallbackSrc={noCourseImg}
        srcAlt={`${courseName} ${courseNumber}`}
        skeletonDuringImageLoad
      />
      <div className="px-4 py-2 text-left x-small">{courseNumber}</div>
      <Card.Header
        title={courseName}
        subtitle={(
          <div>{courseOrg}</div>
        )}
        size="sm"
      />
      <Card.Section />
      {!isLoading && (
        <Button
          as={Link}
          to={courseId ? `/courses/${courseId}/about` : undefined}
          className="mx-4 mb-4"
        >Saiba mais</Button>
      )}
      <Card.Footer className="justify-content-start py-3">
        <Icon className="mr-2" src={Calendar} aria-label={intl.formatMessage(messages.startDate)} />
        {startDateDisplay && intl.formatMessage(messages.startDate, {
          startDate: startDateDisplay,
        })}
      </Card.Footer>
    </Card>
  );
};
// Saberes INTERSSAN: botão "Meus cursos no Studio" em destaque para quem cria
// ou ministra cursos (equipe, criadores de curso, instrutores). O LMS diz se a
// pessoa tem esse papel em /saberes/api/papel/ (saberes_platform.views.papel).
// (estilo fora do JSX: chaves duplas quebrariam o Jinja do Tutor)
const SABERES_STUDIO_BTN_STYLE = {
  background: '#F6AE2F',
  color: '#1D1300',
  borderRadius: 999,
  fontWeight: 600,
  padding: '6px 14px',
  marginRight: 12,
  whiteSpace: 'nowrap',
  boxShadow: '0 6px 16px rgba(246,174,47,.35)',
};

const SaberesStudioButton = () => {
  const [papel, setPapel] = useState(null);

  useEffect(() => {
    const lms = getConfig().LMS_BASE_URL;
    fetch(`${lms}/saberes/api/papel/`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => setPapel(data))
      .catch(() => setPapel(null));
  }, []);

  if (!papel || !papel.criador) {
    return null;
  }
  return (
    <a
      href={papel.studio_url}
      className="btn btn-sm saberes-studio-btn"
      style={SABERES_STUDIO_BTN_STYLE}
      title="Abrir o Studio com os cursos que você cria ou ministra"
    >
      Meus cursos no Studio
    </a>
  );
};// Saberes INTERSSAN: "Início" e "Ajuda" nos cabeçalhos dos apps (aulas, discussões, Studio,
// painel do instrutor...). A Ajuda abre um painel com a finalidade da página (a mesma lista
// das páginas do LMS: /saberes/api/paginas/, saberes_platform/paginas.py) e atalhos para a
// página inicial, a Central de ajuda e os chamados.
// (estilos fora do JSX: chaves duplas quebrariam o Jinja do Tutor)
const SABERES_AJUDA_CAIXA = { position: 'relative', display: 'inline-flex', alignItems: 'center', gap: 8, marginRight: 8 };
const SABERES_AJUDA_BOTAO = {
  background: 'transparent', border: '1px solid rgba(1,99,135,.35)', color: 'inherit', borderRadius: 999,
  padding: '4px 12px', fontWeight: 600, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap', textDecoration: 'none',
};
const SABERES_AJUDA_PAINEL = {
  position: 'absolute', right: 0, top: 'calc(100% + 8px)', width: 320, maxWidth: '90vw', background: '#fff',
  color: '#12212A', border: '1px solid #E3EAEE', borderRadius: 14, boxShadow: '0 16px 40px rgba(1,46,64,.18)',
  padding: 16, zIndex: 2000, textAlign: 'left', fontSize: 14, lineHeight: 1.5,
};
const SABERES_AJUDA_TEXTO = { margin: '4px 0 10px', color: '#4A5A63' };
const SABERES_AJUDA_LINK = {
  display: 'block', padding: '8px 0', borderTop: '1px solid #E3EAEE', color: '#016387', fontWeight: 600, textDecoration: 'none',
};

const SaberesAjuda = () => {
  const [aberto, setAberto] = useState(false);
  const [pagina, setPagina] = useState(null);
  const lms = getConfig().LMS_BASE_URL;

  useEffect(() => {
    if (!aberto || pagina) { return; }
    fetch(`${lms}/saberes/api/paginas/`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((dados) => {
        if (!dados) { return; }
        const caminho = window.location.pathname;
        const achada = dados.paginas.find((p) => new RegExp(p.padrao).test(caminho));
        setPagina(achada || { titulo: '', texto: '' });
      })
      .catch(() => setPagina({ titulo: '', texto: '' }));
  }, [aberto]);

  useEffect(() => {
    if (!aberto) { return undefined; }
    const fechar = (e) => { if (e.key === 'Escape') { setAberto(false); } };
    window.addEventListener('keydown', fechar);
    return () => window.removeEventListener('keydown', fechar);
  }, [aberto]);

  const chamado = `${lms}/saberes/chamados/?categoria=tecnico&pagina=${encodeURIComponent(window.location.href)}`;
  return (
    <div style={SABERES_AJUDA_CAIXA} className="saberes-ajuda">
      <a href={`${lms}/`} style={SABERES_AJUDA_BOTAO} title="Página inicial do Saberes">Início</a>
      <button type="button" style={SABERES_AJUDA_BOTAO} aria-expanded={aberto} aria-haspopup="dialog" onClick={() => setAberto(!aberto)}>
        Ajuda
      </button>
      {aberto && (
        <div style={SABERES_AJUDA_PAINEL} role="dialog" aria-label="Ajuda">
          {pagina && pagina.texto ? (
            <div>
              <strong>{pagina.titulo}</strong>
              <p style={SABERES_AJUDA_TEXTO}>{pagina.texto}</p>
            </div>
          ) : null}
          <a style={SABERES_AJUDA_LINK} href={`${lms}/`}>Página inicial do Saberes</a>
          <a style={SABERES_AJUDA_LINK} href={`${lms}/help`}>Central de ajuda</a>
          <a style={SABERES_AJUDA_LINK} href={chamado}>Falar com a equipe (abrir chamado)</a>
          <a style={SABERES_AJUDA_LINK} href={`${lms}/saberes/novidades/`}>Novidades da plataforma</a>
        </div>
      )}
    </div>
  );
};
// Saberes INTERSSAN: lado esquerdo da tela de login/cadastro (authn).
// O authn não tem slots nessa área; este código roda só em /authn e
// acrescenta, fora dos nós controlados pelo React: link de volta à página
// inicial, logo do Saberes clicável, uma linha de propósito no lugar do nome
// longo da plataforma e o selo do INTERSSAN centralizado no rodapé da coluna.
const saberesAuthnEnhance = () => {
  if (typeof window === 'undefined' || !window.location.pathname.startsWith('/authn')) {
    return;
  }
  const apply = () => {
    // a configuração do MFE (LMS_BASE_URL) só chega depois da chamada à API;
    // até lá, não monta nada
    const lms = ((getConfig() || {}).LMS_BASE_URL || '').replace(/\/$/, '');
    if (!lms) {
      return;
    }
    const img = (name) => `${lms}/static/indigo/images/${name}?v=2`;
    const col = document.querySelector('.layout .bg-primary-400');
    if (!col || col.getAttribute('data-saberes') === '1') {
      return;
    }
    const h1 = col.querySelector('h1');
    if (!h1) {
      return;
    }
    col.setAttribute('data-saberes', '1');
    col.classList.add('sab-authn-col');

    const top = document.createElement('div');
    top.className = 'sab-authn-top';
    top.innerHTML = `
      <a class="sab-authn-back" href="${lms}/">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        Voltar para a página inicial
      </a>
      <a class="sab-authn-logo" href="${lms}/" aria-label="Saberes INTERSSAN — página inicial">
        <img class="sab-authn-logo__light" src="${img('logo.png')}" alt="Saberes INTERSSAN.org" />
        <img class="sab-authn-logo__dark" src="${img('logo-white.png')}" alt="Saberes INTERSSAN.org" />
      </a>`;
    col.insertBefore(top, col.firstChild);

    // título: "Comece a aprender" + "com Plataforma Saberes, INTERSSAN.org"
    // (".org" em verde) + linha de propósito, tudo dentro do próprio h1 para
    // ficar empilhado em qualquer layout (no desktop o h1 está numa linha flex)
    const original = h1.querySelector('.text-accent-a');
    if (original) {
      original.style.setProperty('display', 'none', 'important');
    }
    const accent = document.createElement('span');
    accent.className = 'sab-authn-accent';
    accent.innerHTML = 'com Plataforma Saberes, INTERSSAN<span class="sab-authn-org">.org</span>';
    h1.appendChild(accent);
    const lede = document.createElement('span');
    lede.className = 'sab-authn-lede';
    lede.textContent = 'Cursos gratuitos e online em Soberania e Segurança Alimentar e Nutricional, feitos por quem pesquisa e atua no território.';
    h1.appendChild(lede);

    const badge = document.createElement('a');
    badge.className = 'sab-authn-badge';
    badge.href = 'https://interssan.org';
    badge.target = '_blank';
    badge.rel = 'noreferrer';
    badge.innerHTML = `<small>Uma iniciativa do</small>
      <img class="sab-authn-badge__light" src="${img('interssan-horizontal.png')}" alt="INTERSSAN — Centro de Inovação em Soberania e Segurança Alimentar" />
      <img class="sab-authn-badge__dark" src="${img('interssan-horizontal-white.png')}" alt="INTERSSAN — Centro de Inovação em Soberania e Segurança Alimentar" />`;
    col.appendChild(badge);
  };
  // lado direito: título e orientação acima das abas, atalho de ajuda embaixo; o texto
  // acompanha a aba (Entrar / Registrar), que troca sem recarregar a página
  const direita = () => {
    const lms = ((getConfig() || {}).LMS_BASE_URL || '').replace(/\/$/, '');
    const main = document.querySelector('.layout .main-content');
    if (!lms || !main) {
      return;
    }
    let cab = main.querySelector('.sab-authn-cabecalho');
    if (!cab) {
      cab = document.createElement('div');
      cab.className = 'sab-authn-cabecalho';
      main.insertBefore(cab, main.firstChild);
      const rod = document.createElement('p');
      rod.className = 'sab-authn-rodape';
      rod.innerHTML = `Precisa de ajuda? <a href="${lms}/contact">Fale com a equipe do Saberes</a>.`;
      main.appendChild(rod);
    }
    const registrar = window.location.pathname.indexOf('/register') !== -1;
    const modo = registrar ? 'registrar' : 'entrar';
    if (cab.getAttribute('data-modo') !== modo) {
      cab.setAttribute('data-modo', modo);
      cab.innerHTML = registrar
        ? '<h2>Crie sua conta gratuita</h2><p>Leva menos de um minuto. Depois, complete seu perfil (nome completo e foto) para receber os certificados dos cursos.</p>'
        : '<h2>Que bom ter você aqui</h2><p>Entre com o e-mail e a senha que você cadastrou. Primeira vez no Saberes? Clique em <b>Registrar</b>: é gratuito.</p>';
    }
  };
  const tudo = () => { apply(); direita(); };
  tudo();
  const obs = new MutationObserver(tudo);
  obs.observe(document.documentElement, { childList: true, subtree: true });
};
// Saberes INTERSSAN: faixa de boas-vindas na página inicial do Studio
// (MFE authoring, /authoring/home). O Studio não tem slot nessa área; este
// código insere a faixa acima do título "Studio" e não mexe nos nós do React.
const saberesStudioHomeEnhance = () => {
  if (typeof window === 'undefined' || !window.location.pathname.startsWith('/authoring')) {
    return;
  }
  const apply = () => {
    // LMS_BASE_URL só existe depois que o MFE carrega a configuração
    const lms = ((getConfig() || {}).LMS_BASE_URL || '').replace(/\/$/, '');
    if (!lms) {
      return;
    }
    const central = `${lms}/saberes/professor/`;
    if (!/\/authoring\/?(home)?\/?$/.test(window.location.pathname)) {
      return;
    }
    const sub = document.querySelector('.studio-home-sub-header');
    if (!sub || document.querySelector('.sab-studio-hero')) {
      return;
    }
    const h = new Date().getHours();
    let greet = 'Boa noite! Vamos criar?';
    if (h < 5) { greet = 'Boa noite! Sem sono? Bora criar algo incrível.'; }
    else if (h < 7) { greet = 'Bom dia! Acordou cedo para criar.'; }
    else if (h < 12) { greet = 'Bom dia! Vamos criar?'; }
    else if (h < 18) { greet = 'Boa tarde! Vamos criar?'; }
    const hero = document.createElement('section');
    hero.className = 'sab-studio-hero';
    hero.innerHTML = `
      <div class="sab-studio-hero__text">
        <p class="sab-studio-hero__eyebrow">${greet} · Studio do Saberes</p>
        <h2>Crie cursos que engajam</h2>
        <p>Vídeos com questionário, atividades H5P, mapas mentais, arrastar e soltar e analytics avançado — tudo já habilitado nos seus cursos.</p>
        <div class="sab-studio-hero__ctas">
          <a class="sab-studio-hero__btn sab-studio-hero__btn--cta" href="${central}#primeiros-passos">Guia passo a passo</a>
          <a class="sab-studio-hero__btn" href="${central}#recursos">Recursos disponíveis</a>
          <a class="sab-studio-hero__btn" href="${central}#migrar">Trazer do Moodle ou Classroom</a>
        </div>
      </div>
      <ul class="sab-studio-hero__tips" aria-label="Atalhos">
        <li><b>1.</b> Clique em <em>Novo curso</em> (botão acima à direita)</li>
        <li><b>2.</b> Monte seções, subseções e unidades</li>
        <li><b>3.</b> Em <em>Avançado</em>, escolha os componentes interativos</li>
        <li><b>4.</b> Publique e acompanhe no analytics</li>
      </ul>`;
    const article = sub.closest('section') || sub;
    article.parentNode.insertBefore(hero, article);
  };
  apply();
  const obs = new MutationObserver(apply);
  obs.observe(document.documentElement, { childList: true, subtree: true });
};// Saberes INTERSSAN: explicações dentro do Studio (MFE authoring), pedidos 68, 70 e 71 (03/10/2026).
//  - Biblioteca (/authoring/libraries e /authoring/library/...): para que serve e como usar;
//  - Taxonomias (/authoring/taxonomies e /authoring/taxonomy/...): o que são, exemplos e por que importam;
//  - "Adicionar componente avançado": nome em português e "O que é e quando usar" em cada opção.
// O Studio não tem slot nessas áreas: como em SaberesStudioHome.jsx, o código insere caixas
// próprias (classes sab-explica*) sem mexer nos nós do React, e reaplica quando a página muda.
const SABERES_AVANCADOS = {
  openedx_cmi5_xblock: ['Módulo cmi5', 'Pacote no padrão cmi5 (xAPI) exportado de ferramentas de autoria como Articulate, iSpring ou Adapt, com registro detalhado do que o estudante faz.', 'Quando você já tem conteúdo pronto nessas ferramentas.'],
  done: ['Marcar como concluído', 'Um botão para o estudante marcar a unidade como feita; conta na conclusão do curso.', 'Em leituras, vídeos externos ou tarefas feitas fora da plataforma.'],
  conditional: ['Condicional', 'Mostra um conteúdo só depois que o estudante responde ou conclui outro componente.', 'Para liberar a resposta comentada ou um material extra depois da tentativa.'],
  h5pxblock: ['Conteúdo H5P', 'Atividades interativas (questionário, vídeo interativo, arrastar, linha do tempo, cartões…) a partir de um pacote .h5p.', 'Para aulas mais dinâmicas. Crie o pacote no Lumi (gratuito) ou no h5p.org e envie aqui.'],
  controlled_navigation: ['Navegação controlada', 'Mostra os itens um por vez, na ordem, e só deixa avançar depois do anterior.', 'Em sequências que precisam ser feitas passo a passo.'],
  edx_sga: ['Envio de arquivo com correção da equipe', 'O estudante envia um arquivo (relatório, foto, plano de ação) e a equipe corrige e dá a nota.', 'Em trabalhos práticos e produções que precisam de leitura humana.'],
  split_test: ['Experiência com conteúdo (A/B)', 'Mostra versões diferentes do conteúdo para grupos diferentes de estudantes.', 'Para comparar duas formas de ensinar. Exige grupos de experimento em Configurações › Avançadas.'],
  'google-calendar': ['Google Agenda', 'Incorpora uma agenda pública do Google na unidade (datas do curso, prazos).', 'Para mostrar o calendário da turma. Encontros com sala do Meet: use a aba “Encontros ao vivo” do curso.'],
  'google-document': ['Documento do Google', 'Incorpora um Documento, Planilha ou Apresentação do Google publicado na web.', 'Para materiais que você atualiza com frequência no Google Drive.'],
  'image-explorer': ['Explorador de imagem', 'Uma imagem com pontos clicáveis que abrem textos, fotos ou vídeos.', 'Mapa do bairro, rótulo de alimento, foto de uma feira: o estudante explora as partes.'],
  jupyter: ['Notebook Jupyter', 'Exercícios de análise de dados e programação em Python, no navegador.', 'Em cursos com dados (ex.: indicadores de SAN do município).'],
  lti_consumer: ['Ferramenta externa (LTI)', 'Integra ferramentas de outros sites que seguem o padrão LTI (simuladores, laboratórios virtuais, provas externas).', 'Quando a ferramenta oferece integração LTI; peça a chave a quem a fornece.'],
  mindmap: ['Mapa mental', 'O estudante (ou você) monta um mapa mental dentro da aula; pode valer nota.', 'Para organizar ideias de um tema ou fechar uma unidade.'],
  scorm: ['Módulo SCORM', 'Pacote SCORM vindo do Moodle ou de ferramentas de autoria, com nota e conclusão.', 'Para trazer conteúdos prontos de outras plataformas.'],
  pdf: ['PDF', 'Mostra um PDF dentro da unidade, com link para baixar.', 'Textos de apoio, cartilhas, guias.'],
  poll: ['Enquete', 'Uma pergunta rápida, sem resposta certa; a turma vê o resultado.', 'Para saber a opinião ou a realidade da turma (“Você já participou de um conselho?”).'],
  sortable: ['Problema de ordenação', 'O estudante arrasta os itens para a ordem certa.', 'Etapas de um processo, cronologia de políticas públicas.'],
  invideoquiz: ['Questionário no vídeo', 'O vídeo pausa e faz perguntas em momentos que você escolhe.', 'Para manter a atenção e checar o entendimento em vídeos longos.'],
  survey: ['Pesquisa', 'Várias perguntas de opinião com a mesma escala.', 'Avaliação do curso ou de uma unidade.'],
  'webhook-xblock': ['Webhook (envio de dados)', 'Envia os dados de uma atividade para outro sistema.', 'Uso técnico, combinado com a equipe do Saberes.'],
  word_cloud: ['Nuvem de palavras', 'Cada estudante escreve algumas palavras e a turma vê a nuvem que se forma.', 'Abrir um tema (“O que é comida de verdade para você?”).'],
};

const SABERES_CAIXAS = {
  biblioteca: {
    titulo: 'Para que serve a Biblioteca?',
    html: `<p>A Biblioteca é um <b>acervo de conteúdos reutilizáveis</b>: textos, vídeos, problemas e até unidades inteiras que você monta uma vez e usa em vários cursos. Quando você atualiza algo na biblioteca, os cursos que usam aquele conteúdo recebem o aviso e você decide quando aplicar.</p>
      <ol>
        <li><b>Crie a biblioteca</b> (botão “Nova biblioteca”). Ex.: “Banco de questões de SAN”, “Vídeos do Guia Alimentar”.</li>
        <li><b>Adicione conteúdos</b>: componentes ou unidades, organizados em coleções por tema.</li>
        <li><b>Publique</b> as alterações da biblioteca.</li>
        <li><b>Use no curso</b>: na unidade, escolha <em>Conteúdo da Biblioteca</em> (um item) ou <em>Banco de Problemas</em> (sorteia algumas questões para cada estudante — ótimo para a prova final).</li>
      </ol>
      <p class="sab-explica__dica">Dica: um banco de questões por unidade facilita montar provas diferentes para cada pessoa e reaproveitar em turmas novas.</p>`,
  },
  taxonomias: {
    titulo: 'Etiquetas (taxonomias): o que são e por que importam',
    html: `<p>Taxonomias são <b>conjuntos de etiquetas</b> para classificar cursos, unidades, componentes e itens da biblioteca, do mesmo jeito em toda a plataforma.</p>
      <div class="sab-explica__grade">
        <div><b>Exemplos para o Saberes</b><ul>
          <li><b>ODS</b>: ODS 2 Fome zero, ODS 3 Saúde, ODS 12 Consumo responsável</li>
          <li><b>Eixo da SAN</b>: produção, acesso, consumo, políticas públicas</li>
          <li><b>Público</b>: agentes de saúde, conselheiros, merendeiras, estudantes</li>
          <li><b>Nível</b>: introdutório, intermediário, avançado</li>
          <li><b>Tipo de atividade</b>: leitura, vídeo, prática, avaliação</li>
        </ul></div>
        <div><b>Por que importa</b><ul>
          <li>Achar conteúdo na busca do Studio e da biblioteca</li>
          <li>Reaproveitar materiais entre professores</li>
          <li>Ver números por tema nos painéis de dados</li>
          <li>Mostrar ao estudante cursos do mesmo assunto</li>
        </ul></div>
      </div>
      <p><b>Como usar:</b> a coordenação cria as taxonomias (ou importa um modelo em CSV/JSON) e cada professor aplica as etiquetas em <em>Gerenciar etiquetas</em> nos itens do curso.</p>`,
  },
};

const saberesStudioExplica = () => {
  if (typeof window === 'undefined' || !window.location.pathname.startsWith('/authoring')) {
    return;
  }
  const caixa = (chave) => {
    const c = SABERES_CAIXAS[chave];
    const el = document.createElement('details');
    el.className = `sab-explica sab-explica--${chave}`;
    el.setAttribute('data-sab-explica', chave);
    try { el.open = window.localStorage.getItem(`sab-explica-${chave}`) !== 'fechado'; } catch (e) { el.open = true; }
    el.innerHTML = `<summary>${c.titulo}</summary><div class="sab-explica__corpo">${c.html}</div>`;
    el.addEventListener('toggle', () => {
      try { window.localStorage.setItem(`sab-explica-${chave}`, el.open ? 'aberto' : 'fechado'); } catch (e) { /* sem armazenamento */ }
    });
    return el;
  };
  const apply = () => {
    const p = window.location.pathname;
    const tab = new URLSearchParams(window.location.search).get('tab');
    // Biblioteca: lista (aba Bibliotecas) e página de uma biblioteca
    const naBiblioteca = /\/authoring\/libraries\/?$/.test(p) || /\/authoring\/library\//.test(p) || tab === 'libraries';
    if (naBiblioteca && !document.querySelector('[data-sab-explica="biblioteca"]')) {
      const ancora = document.querySelector('.studio-home-sub-header') || document.querySelector('main h1, main h2, .library-authoring-page h2');
      const alvo = ancora && (ancora.closest('section, header') || ancora);
      if (alvo && alvo.parentNode) {
        alvo.parentNode.insertBefore(caixa('biblioteca'), alvo.nextSibling);
      }
    }
    if (/\/authoring\/taxonom(y|ies)/.test(p) && !document.querySelector('[data-sab-explica="taxonomias"]')) {
      const titulo = document.querySelector('.sub-header-title');
      const alvo = titulo && (titulo.closest('section, header, .sub-header') || titulo);
      if (alvo && alvo.parentNode) {
        alvo.parentNode.insertBefore(caixa('taxonomias'), alvo.nextSibling);
      }
    }
    // "Adicionar componente avançado": nome em português + explicação recolhível
    document.querySelectorAll('[role="dialog"] input.pgn__form-radio-input').forEach((input) => {
      const info = SABERES_AVANCADOS[input.value];
      const radio = input.closest('.pgn__form-radio');
      if (!info || !radio || radio.querySelector('.sab-explica-comp')) {
        return;
      }
      const rotulo = radio.querySelector('label');
      if (rotulo) {
        rotulo.textContent = info[0];
      }
      const d = document.createElement('details');
      d.className = 'sab-explica-comp';
      d.innerHTML = `<summary>O que é e quando usar</summary><p>${info[1]}</p><p><b>Quando usar:</b> ${info[2]}</p>`;
      (rotulo ? rotulo.parentNode : radio).appendChild(d);
    });
  };
  apply();
  // o Studio muda o DOM o tempo todo: agrupa as reaplicações em um quadro de animação
  let agendado = false;
  const obs = new MutationObserver(() => {
    if (agendado) { return; }
    agendado = true;
    window.requestAnimationFrame(() => { agendado = false; apply(); });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
};
// Saberes INTERSSAN (pedido 196, etapas B1–B3 do relatório “Saberes mais simples”): o progresso numa linguagem só,
// no modelo da tela de estudo escolhida pelo André (trilha de passos com tipo e tempo, uma barra, um próximo passo).
// Os dados vêm de /saberes/api/progresso/<curso>/ (saberes_platform/progresso.py). Estilos no CSS do tema das MFEs
// (tools/build_mfe_theme.py, classes sab-proximo / sab-trilha / sab-resumo) — sem objeto de estilo direto no JSX: chaves duplas
// quebrariam o Jinja do Tutor.
const sabCursoDaUrl = () => {
  const m = window.location.pathname.match(/course\/(course-v1:[^/]+)/);
  return m ? decodeURIComponent(m[1]) : null;
};
const sabPaginaDaUrl = () => {
  const m = window.location.pathname.match(/(block-v1:[^/]+type@vertical[^/]*)/);
  return m ? decodeURIComponent(m[1]) : null;
};
const sabProgresso = (curso, pagina) => {
  const q = pagina ? `?pagina=${encodeURIComponent(pagina)}` : '';
  return fetch(`${getConfig().LMS_BASE_URL}/saberes/api/progresso/${encodeURIComponent(curso)}/${q}`, { credentials: 'include' })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null);
};
// o app de cursos troca de página sem recarregar: acompanha o endereço para atualizar a trilha
const useSabEndereco = () => {
  const [endereco, setEndereco] = useState(window.location.pathname);
  useEffect(() => {
    const t = setInterval(() => {
      if (window.location.pathname !== endereco) {
        setEndereco(window.location.pathname);
      }
    }, 700);
    return () => clearInterval(t);
  }, [endereco]);
  return endereco;
};
const sabRotaDaPagina = (curso, passo) => `/course/${curso}/${passo.aula_id}/${passo.pagina_id}`;
const SAB_ICONE = {
  Leitura: '📖', Vídeo: '▶', Questão: '✎', Atividade: '✋', Entrega: '⬆', Enquete: '☑', Experiência: '◎',
  Verificação: '✔', Conversa: '💬',
};

const SabBarra = ({ pct, rotulo }) => {
  const largura = { width: `${Math.max(0, Math.min(100, pct))}%` };
  return (
    <div className="sab-barra" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={pct} aria-label={rotulo}>
      <span style={largura} />
    </div>
  );
};

// B1 — início do curso: o próximo passo com nome, tipo e tempo, e “N de M aulas”
const SaberesProximoPasso = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const curso = sabCursoDaUrl();
    if (curso) {
      sabProgresso(curso).then(setD);
    }
  }, []);
  if (!d) {
    return null;
  }
  const p = d.proximo;
  const curso = sabCursoDaUrl();
  return (
    <section className="sab-proximo" aria-label="Seu próximo passo">
      {p ? (
        <div className="sab-proximo__passo">
          <p className="sab-proximo__rotulo">{p.comecou ? 'Seu próximo passo' : 'Comece por aqui'}</p>
          <h2 className="sab-proximo__titulo">{p.pagina}</h2>
          <p className="sab-proximo__meta">
            <span className="sab-chip">{SAB_ICONE[p.tipo] || '•'} {p.tipo}</span>
            <span>{p.aula}</span>
            <span>~{p.minutos} min</span>
          </p>
          <Link className="btn btn-brand sab-proximo__botao" to={sabRotaDaPagina(curso, p)}>
            {p.comecou ? 'Continuar' : 'Começar'}
          </Link>
        </div>
      ) : (
        <div className="sab-proximo__passo">
          <p className="sab-proximo__rotulo">Curso concluído</p>
          <h2 className="sab-proximo__titulo">Você passou por todas as páginas do curso.</h2>
        </div>
      )}
      <div className="sab-proximo__progresso">
        <p><b>{d.aulas.feitas} de {d.aulas.total} aulas</b> · {d.pct}% do curso</p>
        <SabBarra pct={d.pct} rotulo={`${d.pct}% do curso concluído`} />
        {d.certificado ? <p className="sab-proximo__cert">{d.certificado}</p> : null}
        {d.pasta ? (
          <a className="sab-proximo__pasta" href={d.pasta} target="_blank" rel="noopener noreferrer">📁 Pasta da turma no Drive</a>
        ) : null}
      </div>
    </section>
  );
};

// B2 — aula: a trilha das páginas da aula atual (tipo, tempo, ✓) e “página 2 de 5”
const SaberesTrilha = () => {
  const endereco = useSabEndereco();
  const [d, setD] = useState(null);
  useEffect(() => {
    const curso = sabCursoDaUrl();
    const pagina = sabPaginaDaUrl();
    if (curso && pagina) {
      sabProgresso(curso, pagina).then(setD);
    }
  }, [endereco]);
  const curso = sabCursoDaUrl();
  const t = d && d.trilha;
  if (!t) {
    return (
      <nav className="sab-trilha" aria-label="Páginas da aula">
        <Link className="sab-trilha__voltar" to={`/course/${curso}/home`}>← Todas as aulas</Link>
      </nav>
    );
  }
  return (
    <nav className="sab-trilha" aria-label={`Páginas da aula ${t.aula}`}>
      <Link className="sab-trilha__voltar" to={`/course/${curso}/home`}>← Todas as aulas</Link>
      <p className="sab-trilha__aula">{t.aula}</p>
      <p className="sab-trilha__pos">Página {t.posicao} de {t.total} · {t.passos.filter((p) => p.feita).length} feita(s)</p>
      <SabBarra
        pct={Math.round((100 * t.passos.filter((p) => p.feita).length) / t.total)}
        rotulo={`${t.passos.filter((p) => p.feita).length} de ${t.total} páginas feitas`}
      />
      <ol className="sab-trilha__passos">
        {t.passos.map((p, i) => (
          <li key={p.pagina_id} className={`sab-passo${p.atual ? ' sab-passo--atual' : ''}${p.feita ? ' sab-passo--feito' : ''}`}>
            <Link to={sabRotaDaPagina(curso, p)} aria-current={p.atual ? 'step' : undefined}>
              <span className="sab-passo__marca" aria-hidden="true">{p.feita ? '✓' : i + 1}</span>
              <span className="sab-passo__texto">
                <small>{SAB_ICONE[p.tipo] || '•'} {p.tipo} · ~{p.minutos} min</small>
                <b>{p.pagina}</b>
              </span>
              <span className="sr-only">{p.feita ? ' (concluída)' : ''}</span>
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  );
};

// B3 — progresso: uma frase que se entende sozinha, antes dos números do Open edX
const SaberesProgressoResumo = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const curso = sabCursoDaUrl();
    if (curso) {
      sabProgresso(curso).then(setD);
    }
  }, []);
  if (!d) {
    return null;
  }
  return (
    <section className="sab-resumo" aria-label="Resumo do seu progresso">
      <p className="sab-resumo__frase">
        Você concluiu <b>{d.aulas.feitas} de {d.aulas.total} aulas</b> ({d.pct}% do curso).
      </p>
      <SabBarra pct={d.pct} rotulo={`${d.pct}% do curso concluído`} />
      {d.certificado ? <p className="sab-resumo__cert">{d.certificado}</p> : null}
    </section>
  );
};
  addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'indigo_footer',
            type: DIRECT_PLUGIN,
            priority: 1,
            RenderWidget: IndigoFooter,
        },
    },
]);
  addPlugins(config, 'desktop_secondary_menu_slot', [
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'saberes_ajuda',
            type: DIRECT_PLUGIN,
            priority: 4,
            RenderWidget: SaberesAjuda,
        },
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'saberes_studio_button',
            type: DIRECT_PLUGIN,
            priority: 5,
            RenderWidget: SaberesStudioButton,
        },
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'theme_switch_button',
            type: DIRECT_PLUGIN,
            RenderWidget: ToggleThemeButton,
        },
    },
]);
  addPlugins(config, 'mobile_header_slot', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'theme_switch_button',
            type: DIRECT_PLUGIN,
            RenderWidget: MobileViewHeader,
        },
    },
]);
  addPlugins(config, 'logo_slot', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'custom_logo',
            type: DIRECT_PLUGIN,
            RenderWidget: ThemedLogo,
        }
    }
]);
if (config.pluginSlots && config.pluginSlots['logo_slot']) {
  config.pluginSlots['logo_slot'].keepDefault = false;

  const logoInsertPlugins =
    config.pluginSlots['logo_slot'].plugins.filter(plugin => plugin.op === 'insert' && plugin.widget?.id === 'custom_logo');

  if (logoInsertPlugins.length > 1) {
    let kept = false;
    config.pluginSlots['logo_slot'].plugins =
      config.pluginSlots['logo_slot'].plugins.filter(plugin => {
        if (plugin.op === 'insert' && plugin.widget?.id === 'custom_logo') {
          if (kept) return false;
          kept = true;
        }
        return true;
      });
  }
}

if (config.pluginSlots && config.pluginSlots['org.openedx.frontend.layout.footer.v1']) {
  const footerPluginsToInsert =
    config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins.filter(plugin => plugin.op === 'insert');

  if (footerPluginsToInsert.length > 2) {
  config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins =
    config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins.filter(plugin => {
      if (plugin.op === 'insert') {
        const widgetId = plugin.widget?.id;
        return widgetId !== 'indigo_footer';
      }
      return true;
    });
  }
}

// Saberes: lado esquerdo da tela de login (ver SaberesAuthn.jsx)
saberesAuthnEnhance();
// aviso de cookies e GA só com consentimento, em todos os apps (pedido 139)
saberesCookies();

// Saberes: faixa de boas-vindas na home do Studio (ver SaberesStudioHome.jsx)
saberesStudioHomeEnhance();

// Saberes: explicações no Studio — Biblioteca, Taxonomias, componentes avançados (ver SaberesStudioExplica.jsx)
saberesStudioExplica();

  return config;
}

export default setConfig;